import { TeachingStaffDatamodel } from '../../teaching-staff/teaching-staff';
import { LecturerType } from '../../../../../api/types/programs/course/lecturers/course-lecturer';

export const transformToStaffOperation = (
  lecturer: LecturerType[],
): TeachingStaffDatamodel[] => {
  return lecturer.map(
    (lecturerItem) =>
      ({
        ...lecturerItem,
        isMajorTeacher: false,
      }) as TeachingStaffDatamodel,
  );
};
